import React from 'react';
import { SessionStorage } from 'core-lib/constants/storage';
import { handleBack } from 'core-lib/utils/common';

function NativeBackHandler() {
  function handleClick() {
    const activeBtnClass = sessionStorage.getItem(
      SessionStorage.ActiveBackBtnClass
    );
    if (activeBtnClass) {
      const parsedClasses = JSON.parse(activeBtnClass);
      if (Array.isArray(parsedClasses) && parsedClasses?.length) {
        const activeBtnElem = document.getElementsByClassName(
          parsedClasses[parsedClasses.length - 1]
        );
        if (activeBtnElem[0]) {
          // @ts-ignore
          activeBtnElem[0].click();
        }
      }
    } else {
      handleBack();
    }
  }

  return (
    <button
      id="cmn_page_header_back_btn"
      type="button"
      style={{ display: 'none' }}
      onClick={() => handleClick()}
    >
      -
    </button>
  );
}

export default NativeBackHandler;
